define(
    ['underscore', 'jquery'],
    (_, $) => {
        /**
         * This function defines a new layout:
         * * Registers a wrapper directive for the layout
         * * Registers directives for any partials defined for the layout
         *
         * @param {string}      layoutName  Layout name string. Layout will be automatically prefixed with 'gw-'
         * @param {string}      template    Layout template string.
         * @param {function}    definition  Definition function. 'createPartial' method is passed in to define partials.
         */
        return (layoutName, template, definition) => {
            const layoutDirectiveName = `gw${layoutName}`; //gwSomeLayout
            const moduleName = `edge.platform.layout.${layoutName}`;

            //Create a separate module for the layout and the outer directive
            const module = angular.module(moduleName, [])
                .directive(layoutDirectiveName, ['$compile', ($compile) => ({
                    restrict: 'E',

                    controller: ['$scope', function () {
                        /**
                         * A map storing arrays of partials registered for a given name
                         * @type {Object<string, function[]>}
                         */
                        this.partials = {};
                    }],

                    //Make sure this doesn't creates a new state —
                    //current state should be used so that layouts are transparent
                    //for any inner directives with two-way binding
                    scope: false,
                    link: (scope, element, attr, layoutController) => {
                        //Render the template after partials have been collected
                        element.empty().append($compile(template)(scope));

                        _.forEach(layoutController.partials, (partials, name) => {
                            //For each known partial type (by name), find an element where partials of that type should be applied.
                            //For every such element and every partial of the given type clone the element and put transcluded contents in.
                            element
                                .find(`[gw-partial=${name}]`) //Searches for gw-partial-SomePartial
                                .each((i, partialLocation) => {
                                    const $partialLocation = $(partialLocation);
                                    const filledPartials = [];

                                    partials.forEach(transclude => {
                                        const parent = $partialLocation.clone();

                                        //Get the transcluded contents. Transclude binding to outer scope (see above)
                                        transclude(scope, clonedElement => {
                                            parent.append(clonedElement);
                                            filledPartials.push(parent);
                                        }, parent);
                                    });

                                    //Put all the prepared partials into DOM and remove an initial wrapper element
                                    //(it was cloned to create another partial, but was not used itself)
                                    $partialLocation.after(filledPartials);
                                    $partialLocation.remove();
                                });
                        });
                    }
                })]);

            const createPartial = partialName => {
                //Register a partial directive to capture types of content inside the layout
                module.directive(`${layoutDirectiveName}${partialName}`, () => ({ //gwSomeLayoutSomePartial
                    restrict: 'E',
                    require: `^^${layoutDirectiveName}`,
                    transclude: true,
                    scope: false,
                    link: (scope, element, attrs, ctrl, $transclude) => {
                        //Register the transclude function with the layout wrapper
                        //The directive itself is discarded afterwards, only the transclude function is used.
                        ctrl.partials[partialName] = ctrl.partials[partialName] || [];
                        ctrl.partials[partialName].push($transclude);
                    }
                }));
            };

            definition(createPartial);

            return moduleName;
        };
    }
);


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/layouts/LayoutFactory.js